import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useUpdateEffect } from 'react-use';
import SubUserRegisterCard from './SubUserRegisterCard';
import NewModal from '../NewModal';
import { isNullOrEmpty } from '../../common/util';

const SubUserModal = ({
  open,
  bDel,
  items,
  robots,
  // onSearch,
  onChange,
  onUpdate,
  onCancel,
}) => {
  const [selected, setSelected] = useState([]);
  const [robotList, setRobotList] = useState([]);
  const [serials, setSerials] = useState([]);

  const updateButtons = [
    { label: '취소', onClick: () => onCancel() },
    {
      label: bDel ? '선택 삭제' : '선택 수정',
      color: bDel && 'error',
      onClick: () => onUpdate(selected),
    },
  ];

  const onSelecteChange = (id) => {
    const selectedIndex = selected.indexOf(id);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const onInfoChange = (info) => {
    const { name, value } = info;
    if (name === 'serial') {
      const list = robotList.length ? robotList : robots;
      if (value) {
        setRobotList(robots.filter(({ serial: s }) => s !== value));
      } else if (list.find(({ id }) => info.rId === id)) {
        setRobotList([...list]);
      } else {
        setRobotList([...list, robots.find(({ id }) => info.rId === id)]);
      }
    }
    if (name === 'item-check') {
      onSelecteChange(value);
    } else {
      onChange(info);
      // updateList.splice(idx, 1, { ...updateList[idx], [name]: value });
      // setList(updateList);
    }
  };

  const onSearch = (v) => {
    const check = v.toLowerCase();

    if (robotList.length === 0) {
      setRobotList(robots.filter(({ serial: s }) => !serials.includes(s)));
    } else {
      setRobotList(
        robots.filter(
          (robot) =>
            (isNullOrEmpty(robot.group)
              ? false
              : robot.group.name.toLowerCase().trim().indexOf(check) > -1) ||
            robot.alias.toLowerCase().trim().indexOf(check) > -1 ||
            robot.serial.toLowerCase().trim().indexOf(check) > -1,
        ),
      );
    }
  };

  useUpdateEffect(() => {
    setSerials(items.map(({ serial: s }) => s));
    setSelected(items.map(({ id }) => id));
  }, [items]);

  return (
    <NewModal open={open} buttons={updateButtons} onClose={onCancel}>
      <Grid container spacing={1}>
        {bDel && (
          <Grid item xs={12}>
            <Typography variant="h5">
              다음과 같이 선택 된 사용자와 관련된 정보를 모두 삭제하시겠습니까?
            </Typography>
          </Grid>
        )}
        {items &&
          items.map((item, i) => (
            <Grid
              item
              xs={items.length === 1 ? 12 : 6}
              key={item.id || item.serialId || `update_${i}`}
            >
              <SubUserRegisterCard
                {...{
                  ...item,
                  robotList,
                  bUpdate: !bDel,
                  bDel,
                  index: i,
                  checked: selected.indexOf(item.id) > -1,
                  onInfoChange,
                  onSearch,
                }}
              />
            </Grid>
          ))}
      </Grid>
    </NewModal>
  );
};

export default SubUserModal;
